import { P2GAlert, P2GFade, P2GLink, P2GText } from '@parcel2go/core-ui';
import { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import useSignIn from '~/hooks/use-signin';
import { TranslationNamespaces } from '~/lib/constants';

export default function SignIn() {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  const { onSignInClick } = useSignIn();

  const onSignIn = useCallback(() => {
    onSignInClick();
  }, [onSignInClick]);

  return (
    <P2GFade in>
      <P2GAlert type="info" dataTestId="login-alert">
        <P2GText variant="body1">
          <Trans
            i18nKey="SIGN_IN_MESSAGE"
            t={t}
            defaults="Already have an account? <0>Sign in</0> to speed up your parcel booking."
            components={[<P2GLink onClick={onSignIn} />]}
          />
        </P2GText>
      </P2GAlert>
    </P2GFade>
  );
}
